'use client';

import React, { useState } from 'react';
import TipSvg from '@/assets/icons/dp-final-price-tip.svg';
import WidthArrowPopover from '../arrowPopover';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from '@/i18n/client';

import styles from './index.module.scss';

interface PopoverWithIconProps {
  children: React.ReactNode;
  clickIcon?: () => void;
}

const ConfirmButton = styled(Button)(() => ({
  color: '#fff',
  backgroundColor: '#CC0C1C',
  lineHeight: '28px',
  padding: '0 8px',
  minWidth: 'auto',
  '&:hover': {
    borderColor: '#990915',
    backgroundColor: '#990915',
    boxShadow: 'none',
  },
}));

const PopoverWithIcon: React.FC<PopoverWithIconProps> = ({ children, clickIcon }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { t } = useTranslation();

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    clickIcon?.();
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className={styles.popoverWithIconWrap}>
      <TipSvg onClick={handlePopoverOpen} />
      <WidthArrowPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {children}
        <div className={styles.footer}>
          <ConfirmButton onClick={handlePopoverClose}>{t('common.btnText.ok')}</ConfirmButton>
        </div>
      </WidthArrowPopover>
    </div>
  );
};

export default PopoverWithIcon;
